var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9036 6.76268L22.5 5.31669V5H16.9714L13.0312 14.2897L8.54948 5H2.7526V5.31669L4.61719 7.44272C4.79948 7.59984 4.89323 7.83061 4.86979 8.06137V16.4157C4.92708 16.7177 4.82552 17.0245 4.60156 17.243L2.5 19.6563V19.9681H8.45312V19.6514L6.35417 17.2455C6.12621 17.0273 6.01931 16.7214 6.0651 16.4182V9.19067L11.2917 19.973H11.8984L16.3932 9.19067V17.7807C16.3932 18.0065 16.3932 18.0532 16.237 18.2029L14.6198 19.6833V20H22.4635V19.6833L20.9036 18.2373C20.7682 18.1391 20.6979 17.9746 20.7266 17.8151V7.18494C20.6991 7.02424 20.767 6.86224 20.9036 6.76268Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.46863805.svg";
export { ForwardRef as ReactComponent };